export type EventName =
  | 'add_payment_info'
  | 'add_shipping_info'
  | 'begin_checkout'
  | 'remove_from_cart'
  | 'view_item_list'
  | 'add_to_cart'
  | 'purchase'
  | 'create_account'
  | 'non_business_donate_button'
  | 'business_donate_button'
  | 'non_business_fund_button'
  | 'carbon_calculator_input'
  | 'carbon_calculator_slider'
  | 'carbon_calculator_button'
  | 'funding_calculator_tab'
  | 'budget_calculator_input'
  | 'budget_calculator_slider'
  | 'budget_calculator_button'
  | 'trees_calculator_input'
  | 'trees_calculator_slider'
  | 'trees_calculator_button'
  | 'explore_projects_button'
  | 'support_projects_button'
  | 'supported_projects_date_input'

export const trackEvent = (
  eventName: EventName,
  eventParams: { [key: string]: any }
) => {
  if ('gtag' in window && typeof window.gtag === 'function')
    window.gtag('event', eventName, eventParams)
}
